import { Component } from '@angular/core';
import { PlaceholderPageComponent } from '../placeholder/placeholder-page.component';

@Component({
  selector: 'app-calculators-page',
  standalone: true,
  imports: [PlaceholderPageComponent],
  template: `
    <app-placeholder-page 
      title="pages.calculators" 
      icon="calculator">
    </app-placeholder-page>
  `
})
export class CalculatorsPageComponent {}